import { Base } from "@/atoms-react/text/Text.react";
import { useTranslation } from "react-i18next";

export const AdminNewCompaniesTableHeader = () => {
  const { t } = useTranslation(["pass"]);

  const textClassName = "text-semibold text-sm lg:text-base w-full";

  return (
    <div className="flex min-w-sm flex-row justify-between p-3 lg:min-w-0">
      <div className="flex min-w-[100px] basis-2/12 items-end">
        <Base className={textClassName}>{t("admin_page.table.header.company")}</Base>
      </div>

      <div className="flex min-w-[100px] basis-1/12 items-end text-center">
        <Base className={textClassName}>{t("admin_page.table.header.registration_number")}</Base>
      </div>

      <div className="flex min-w-[100px] basis-1/12 items-end text-center">
        <Base className={textClassName}>{t("admin_page.table.header.partner")}</Base>
      </div>

      <div className="flex min-w-[100px] basis-1/12 items-end text-center">
        <Base className={textClassName}>{t("admin_page.table.header.olkypass")}</Base>
      </div>

      <div className="flex min-w-[100px] basis-2/12 items-end text-center">
        <Base className={textClassName}>{t("admin_page.table.header.situation")}</Base>
      </div>

      <div className="flex min-w-[100px] basis-1/12 items-end text-center">
        <Base className={textClassName}>{t("admin_page.table.header.representatives_count")}</Base>
      </div>

      <div className="flex min-w-[100px] basis-2/12 items-end text-center">
        <Base className={textClassName}>
          {t("admin_page.table.header.beneficial_owners_count")}
        </Base>
      </div>

      <div className="flex min-w-[100px] basis-1/12 items-end text-center">
        <Base className={textClassName}>{t("admin_page.table.header.last_update")}</Base>
      </div>

      <div className="flex min-w-[100px] basis-1/12 items-end text-end">
        <Base className={textClassName}>{t("admin_page.table.header.action")}</Base>
      </div>
    </div>
  );
};
